import { useTranslation } from 'react-i18next';

import { ReactComponent as EmptyReportImg } from '../../assets/images/empty-report.svg';
// Pass in a title prop to override the default text.
type EmptyReportProps = {
  title?: string;
  img?: string;
};

export default function EmptyReport({ title, img }: EmptyReportProps): JSX.Element {
  const { t } = useTranslation();
  // Use relative path for default image
  const defaultImagePath = 'images/empty-report.svg';

  return (
    <div className="container" data-testid="empty-report-wrapper">
      <div className="mx-auto mt-10 flex h-full w-80 flex-col items-center justify-center gap-5">
        {img ? (
          <img src={img} alt="Empty Report" className="w-28" data-testid="empty-report-img" />
        ) : (
          <EmptyReportImg className="size-full" />
        )}
        <p className="text-center text-2xl text-gray-700" data-testid="empty-report-p">
          {title ? title : t('reports.emptyState.selectOptions')}
        </p>
      </div>
    </div>
  );
}
